import { axiosInstance } from '@/modules/shared/lib/axios';
import { EmailConfigurationPayload } from './types';

type Props = {
  companyId: string
  payload: EmailConfigurationPayload
}

export function updateEmailConfigurationSettings ({ companyId, payload }: Props) {
    return axiosInstance.post<EmailConfigurationPayload>(`/api/${companyId}/configuration/email/updateEmailConfig`, payload);
}
